import { createContext, useContext } from 'react';

import { useLoader } from './hooks/useDispatchLoader';
import { StringWrapperCtor } from './useTranslations';

export interface TranslationsOptions {
  useLoader<T>(from: StringWrapperCtor<T>): T;
}

export const defaultOptions: TranslationsOptions = {
  useLoader,
};
export const TranslationsContext = createContext(defaultOptions);

export type UseTranslationsOptions = () => TranslationsOptions;
export const useTranslationsOptions: UseTranslationsOptions = () => useContext(TranslationsContext);
